import React, { useState } from 'react';
import { api } from '../api'; 
import '../styles/Auth.css';
import logo from '../assets/logo_AuthPages.png';

// --- Login Form Component ---
const LoginForm = ({ onLoginSuccess, onSwitchToRegister, onForgotPassword }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const data = await api.login({ email, password });
            onLoginSuccess(data.accessToken, data.refreshToken);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-card">
            <div className="auth-logo-container">
                <img src={logo} alt="The WesternTech Logo" />
            </div>
            <div className="auth-header">
                <h1>Welcome Back!</h1>
                <p>Sign in to continue to your dashboard.</p>
            </div>
            {error && <div className="error-message">{error}</div>}
            <form className="auth-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="form-label" htmlFor="login-email">Email Address</label>
                    <input id="login-email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="form-input" required disabled={loading} />
                </div>
                <div className="form-group">
                    <label className="form-label" htmlFor="login-password">Password</label>
                    <input id="login-password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="form-input" required disabled={loading} />
                </div>
                <div style={{textAlign: 'right', fontSize: '0.8rem', marginBottom: '1rem'}}>
                    <button type="button" onClick={onForgotPassword} className="auth-switch-link">Forgot Password?</button>
                </div>
                <button type="submit" className="form-button" disabled={loading}>
                    {loading ? 'Signing In...' : 'Sign In'}
                </button>
            </form>
            <p className="auth-switch">
                Don't have an account?{' '}
                <button onClick={onSwitchToRegister} className="auth-switch-link">Register</button>
            </p>
        </div>
    );
};


// --- Registration Form Component ---
// const RegisterForm = ({ onSwitchToLogin }) => {
//     // Removed propertyCode from the initial state
//     const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', password: '' });
//     const [error, setError] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [successMessage, setSuccessMessage] = useState('');

//     const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError(null);
//         setSuccessMessage('');
//         setLoading(true);
//         try {
//             const data = await api.register(formData);
//             setSuccessMessage(data.message || 'Registration successful! You can now sign in.');
//             // Clear form on success
//             setFormData({ firstName: '', lastName: '', email: '', password: '' });
//             // Optionally redirect to login after a delay
//             setTimeout(() => {
//                 onSwitchToLogin();
//             }, 2000);
//         } catch (err) {
//             setError(err.message);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="auth-card">
//             <div className="auth-logo-container">
//                 <img src={logo} alt="The WesternTech Logo" />
//             </div>
//             <div className="auth-header"><h1>Create an Account</h1><p>Register to get access to the platform.</p></div>
//             {error && <div className="error-message">{error}</div>}
//             {successMessage && <div className="success-message">{successMessage}</div>}
//             <form className="auth-form" onSubmit={handleSubmit}>
//                 <div className="form-group"><label className="form-label" htmlFor="firstName">First Name</label><input id="firstName" name="firstName" type="text" value={formData.firstName} onChange={handleChange} className="form-input" required disabled={loading} /></div>
//                 <div className="form-group"><label className="form-label" htmlFor="lastName">Last Name</label><input id="lastName" name="lastName" type="text" value={formData.lastName} onChange={handleChange} className="form-input" required disabled={loading} /></div>
//                 <div className="form-group"><label className="form-label" htmlFor="email">Email Address</label><input id="email" name="email" type="email" value={formData.email} onChange={handleChange} className="form-input" required disabled={loading} /></div>
//                 <div className="form-group"><label className="form-label" htmlFor="password">Password</label><input id="password" name="password" type="password" value={formData.password} onChange={handleChange} className="form-input" required disabled={loading} /></div>
//                 {/* --- Property Code Input Removed --- */}
//                 <button type="submit" className="form-button" disabled={loading}>{loading ? 'Registering...' : 'Register'}</button>
//             </form>
//             <p className="auth-switch">Already have an account? <button onClick={onSwitchToLogin} className="auth-switch-link">Sign In</button></p>
//         </div>
//     );
// };


// --- Forgot Password Form Component ---
const ForgotPasswordForm = ({ onSwitchToLogin }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');
        try {
            const data = await api.forgotPassword(email);
            setMessage(data.message);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-card">
            <div className="auth-logo-container">
                <img src={logo} alt="The WesternTech Logo" />
            </div>
            <div className="auth-header">
                <h1>Reset Password</h1>
                <p>Enter your email to receive a reset link.</p>
            </div>
            {error && <div className="error-message">{error}</div>}
            {message && <div className="success-message">{message}</div>}
            <form className="auth-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="form-label" htmlFor="forgot-email">Email Address</label>
                    <input id="forgot-email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="form-input" required disabled={loading} />
                </div>
                <button type="submit" className="form-button" disabled={loading}>
                    {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
            </form>
            <p className="auth-switch">
                Remember your password?{' '}
                <button onClick={onSwitchToLogin} className="auth-switch-link">Sign In</button>
            </p>
        </div>
    );
};


// --- Landing Page Parent Component ---
const LandingPage = ({ onLoginSuccess }) => {
    const [view, setView] = useState('login'); // 'login', 'register', 'forgot'

    if (view === 'login') {
        return <div className="landing-page"><LoginForm onLoginSuccess={onLoginSuccess} onSwitchToRegister={() => setView('register')} onForgotPassword={() => setView('forgot')} /></div>;
    }
    // if (view === 'register') {
    //     return <div className="landing-page"><RegisterForm onSwitchToLogin={() => setView('login')} /></div>;
    // }
    return <div className="landing-page"><ForgotPasswordForm onSwitchToLogin={() => setView('login')} /></div>;
};

export default LandingPage;
